// 泰国
export const common = {
  cancel:"การยกเลิก",
  confirm:"ยืนยัน",
  country:"ประเทศ"
};
// 订单列表页面
export const orderList = {
  title:"รายการสั่งซื้อ",
};

// 查询页面
export const cardLoop = {
  cardTitle:"หมายเลขซิมการ์ด ICCID",
  cardDesc:"ป้อนหมายเลข ICCID ของซิมการ์ดในกล่องอินพุต",
  query:"ค้นหา",
  title:"แพลตฟอร์มซิมการ์ด IOT",
};

// 详情页面
export const cardInfo = {
  title:"ข้อมูลบัตร",
  msisdn:"MSISDN：",  
  iccid:"ICCID：",
  expiration:"หมดอายุ",//过期时间
  status:'สถานะ',
  refresh:"รีเฟรช",//刷新
  residualFlow:"ส่วนที่เหลือ",
  totalFlow:"ทั้งหมด",
  used:"เคยชิน",
  lists:["การใช้","ไม่ได้ใช้","ดอร์น"],//1 生效中 2 未生效 3.已失效
  validity:"ประสิทธิผล",
  skuUsed:"เคยชิน",
  skuTotal:"ทั้งหมด",
  recharge:"เติมเงิน",//去充值
};

// 选套餐页面
export const cardPlans = {
  title:"รายการแพคเกจโปรแกรม",
  buyPlan:"แผนการซื้อ",
  select:"เลือกแผน",//未选套餐的提示
  orderList:"รายการสั่งซื้อ",
  userAgreement:"ข้อตกลงผู้ใช้",
  price:"ราคาแพ็คเกจ",
  flowCount:"อัตราการไหลรวม",
  validityTime:"วันที่มีผลบังคับใช้",
  switchCountryName:"พื้นที่ใช้สอย",
  productDesc:"คำอธิบายการบรรจุ",
  productDescText:"การชำระเงินล่วงหน้า",
  paymentMethod:"วิธีการชำระเงิน",
  checkUserAgreementMsg:"โปรดตรวจสอบข้อตกลงผู้ใช้",
  payErrorMsg:"การชำระเงิน CNY ไม่รองรับในบัญชีผู้รับเงิน",
  payBtnText:"วิธีการซื้อ",
};


// 完成支付或取消支付
export const cardPayEnd = {
  title:"ผลการชำระเงิน",
  Details:"รายละเอียด",//返回详情
}

export const country = {
  America:'สหรัฐอเมริกา',
  HongKong:'ฮ่องกง',
  Thailand:'ประเทศไทย',
  Philippines:'ประเทศฟิลิปปินส์',
  Macao:'มาเก๊า'
}

// 位置标签
export const placeTitle = "Country";

// 国家名称
export const China = "China"
export const America = "America"
export const HongKong = "Hong Kong"







